import { Box } from "@mui/material";
import {
    CheckCircle as CheckCircleIcon,
    Warning as WarningIcon
} from '@mui/icons-material';

import { Typography } from "@initia-digital/component-library";
import { muiGreen, muiAmber } from "@initia-digital/colors";

interface ContactPersonAlertProps {
    contactPersonName?: string | null;
    warningMessage?: string;
    successMessage?: string;
    showPersonName?: boolean;
}

export const ContactPersonAlert = ({ 
    contactPersonName, 
    warningMessage = "Contact person has not been selected",
    successMessage = "Contact person selected",
    showPersonName = false
}: ContactPersonAlertProps) => {
    const isSelected = Boolean(contactPersonName);
    const displayMessage = isSelected 
        ? (showPersonName && contactPersonName ? `${successMessage}: ${contactPersonName}` : successMessage)
        : warningMessage;

    return (
        <Box 
            my="10px" 
            px="8px" 
            py="8px"
            border={`1px solid ${isSelected ? muiGreen[200] : muiAmber[200]}`} 
            borderRadius="4px"
            lineHeight="1"
            display="flex"
            alignItems="center"
            gap="8px"
        >
            {isSelected ? (
                <CheckCircleIcon 
                    sx={{ color: muiGreen[500], fontSize: '1.2rem' }} 
                />
            ) : (
                <WarningIcon 
                    sx={{ color: muiAmber[600], fontSize: '1.2rem' }} 
                />
            )}
            <Typography
                color={isSelected ? muiGreen[600] : muiAmber[700]}
                fontSize="0.8rem"
                fontWeight={500}
            >
                {displayMessage}
            </Typography>
        </Box>
    );
};